module.exports = __webpack_public_path__ + "static/media/uk.a7fc19d7.png";